exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1C4jm9yjyxcjHTOcqh9NbJ {\n}\n", ""]);

// exports
exports.locals = {
	"getAge": "_1C4jm9yjyxcjHTOcqh9NbJ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/legacy/components/GetAge/GetAge.css
// module id = 8847
// module chunks = 23